import { Accordion, AccordionProps } from '@mui/material';

export const FilterAccordion = (props: AccordionProps) => (
  <Accordion
    sx={{ width: '300px', '&:before': { display: 'none' } }}
    disableGutters
    {...props}
  >
    {props.children}
  </Accordion>
);
